import React, { useEffect, useState } from "react";
import Post from "../../../utils/Post copy";
import Verifiers from "../../../utils/Verifiers";

const CantidadSiembraSemanal = (props) => {
    let { plan, value, dia, tipo, index = -1, fn, disabled } = props;

    const [cantidad, setCantidad] = useState(value);

    useEffect(() => {
        setCantidad(value);
    }, [value]);

    const handleChange = async (e) => {

        let val = +([null, ""].includes(e.target.value) ? 0 : e.target.value);
        setCantidad(val);
        fn(val, index, dia);

        Post('api/getPlanSiembraSemana', { cantidad: val, dia, tipo, plan_id: plan.id });
    };

    return (
        <input className={` form-control form-control-sm m-0 pb-0 pt-0 ${Verifiers.numberParser(value, 0) > 0 ? 'text-bold' : ''} ${cantidad > 0 ? "bg-orange-200" : ""}`}
            style={{ width: '65px' }}
            type="number"
            step="1"
            value={cantidad}
            disabled={disabled}
            onChange={handleChange}
            name="cantidad" />
    );
}

export default CantidadSiembraSemanal;
